const initialState = {
    loading: false,
    error: null,
    data: null,
  };

export const IWORequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_IWO_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_IWO_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload, 
      };
    case "FETCH_IWO_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};